import React, { FC, ReactNode, RefObject, useEffect } from "react";

type BaseConfiguratorModalProps = {
    open: boolean;
    onClose: () => void;
    title: string;
    children: ReactNode;
    footer?: ReactNode;
    contentRef?: RefObject<HTMLDivElement>;
};

export const BaseConfiguratorModal: FC<BaseConfiguratorModalProps> = ({ open, onClose, title, children, footer, contentRef }) => {
    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);

    if (!open) return null;

    const handleBackgroundClick = () => onClose();
    const handleModalClick = (e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation();

    return (
        <div
            className="fixed inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50"
            onClick={handleBackgroundClick}
        >
            <div
                className="relative bg-white w-[90%] h-[90%] flex flex-col"
                onClick={handleModalClick}
            >
                <div className="sticky top-0 bg-white p-4 border-b border-gray-200 flex justify-between items-center z-10">
                    <h2 className="text-xl font-semibold">{title}</h2>
                    <button
                        className="text-gray-500 hover:text-gray-800 text-xl p-2"
                        onClick={onClose}
                    >
                        &times;
                    </button>
                </div>

                <div className="flex-1 overflow-y-auto p-6" ref={contentRef}>
                    <div className="flex flex-col md:flex-row md:flex-wrap gap-4 justify-center">
                        {children}
                    </div>
                </div>

                <div className="sticky bottom-0 bg-white p-4 border-t border-gray-200 flex flex-row flex-wrap justify-center gap-2">
                    {footer}
                </div>
            </div>
        </div>
    );
};
